import { DOMRouteHandler } from './DOMRouteHandler';
import { drawBreedList } from '../modules/breedList';
import { drawDiseaseList } from '../modules/diseaseList';
import initHealthList from '../modules/healthList';
import { initPDPTabs } from '../modules/PDPTabs';

export class TemplatePageInterstitial extends DOMRouteHandler {
  static async initAsync(): Promise<void> {
    await drawDiseaseList();
    await drawBreedList();
    initHealthList();
    initPDPTabs();
  }
}
